import { SxProps, Theme } from '@mui/material';

export const modalContainerStyles: SxProps<Theme> = {
  position: 'fixed',
  top: '50%',
  left: 'calc(100% + 50px)',
  transform: 'translateY(-50%)',
  zIndex: 1300,
};

export const modalPaperStyles: SxProps<Theme> = {
  borderRadius: 2,
  width: 600,
  position: 'relative',
};

export const modalHeaderStyles: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  px: 2,
  py: 1.5,
};

export const modalHeaderIconStyles: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'row',
  gap: 2,
};

export const closeIconStyles: SxProps<Theme> = {
  fontSize: 20,
};

export const modalContentStyles: SxProps<Theme> = {
  backgroundColor: (theme) => theme.palette.grey[100],
  borderRadius: 1,
  display: 'flex',
  flexDirection: 'column',
  gap: 3,
  padding: 2,
  margin: 2,
};

export const audioBoxStyles: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: 2,
  borderRadius: 2,
  border: (theme) => `1px solid ${theme.palette.divider}`,
  backgroundColor: (theme) => theme.palette.common.white,
};

export const audioControlButtonStyles: SxProps<Theme> = {
  backgroundColor: (theme) => theme.palette.primary.main,
  color: 'white',
  '&:hover': {
    backgroundColor: (theme) => theme.palette.primary.dark,
  },
};

export const audioDeleteButtonStyles: SxProps<Theme> = {
  color: (theme) => theme.palette.action.disabled,
  ml: 1,
};

export const progressBarContainerStyles: SxProps<Theme> = {
  flex: 1,
  mx: 2,
  height: 2,
  backgroundColor: '#e0e0e0',
  borderRadius: 2,
  position: 'relative',
};

export const progressBarStyles = (progress: number): SxProps<Theme> => ({
  position: 'absolute',
  left: 0,
  top: 0,
  height: '100%',
  width: `${progress}%`,
  backgroundColor: (theme) => theme.palette.primary.main,
  borderRadius: 2,
});

export const progressHandleStyles = (progress: number): SxProps<Theme> => ({
  position: 'absolute',
  left: `${progress}%`,
  top: '50%',
  transform: 'translate(-50%, -50%)',
  width: 12,
  height: 12,
  borderRadius: '50%',
  backgroundColor: (theme) => theme.palette.primary.main,
  boxShadow: '0 0 3px rgba(0,0,0,0.3)',
});

export const timeDisplayStyles: SxProps<Theme> = {
  border: (theme) => `1px solid ${theme.palette.divider}`,
  borderRadius: 1,
  padding: (theme) => theme.spacing(0.5, 1),
};

export const recordButtonStyles: SxProps<Theme> = {
  backgroundColor: (theme) => theme.palette.primary.main,
  color: 'white',
  width: 58,
  height: 58,
  '&:hover': {
    backgroundColor: (theme) => theme.palette.primary.dark,
  },
};

export const stopRecordingButtonStyles: SxProps<Theme> = {
  backgroundColor: '#ef5350',
  color: 'white',
  '&:hover': {
    backgroundColor: '#d32f2f',
  },
};

export const recordingBoxStyles: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: 2,
  justifyContent: 'space-between',
  padding: 2,
  borderRadius: 2,
  backgroundColor: (theme) => theme.palette.common.white,
  border: (theme) => `1px solid ${theme.palette.divider}`,
};

export const wavesContainerStyles: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  flex: 1,
  height: 40,
};

export const waveStyles = (height: number): SxProps<Theme> => ({
  width: 3,
  height: `${height}px`,
  backgroundColor: '#6200ee',
  mx: 0.5,
  borderRadius: 1,
  animation: 'pulse 0.5s infinite alternate',
  '@keyframes pulse': {
    '0%': {
      height: `${Math.random() * 15 + 5}px`,
    },
    '100%': {
      height: `${Math.random() * 35 + 5}px`,
    },
  },
});

export const uploadButtonStyles: SxProps<Theme> = {
  borderColor: (theme) => theme.palette.primary.main,
  color: (theme) => theme.palette.primary.main,
  borderRadius: 1,
  textTransform: 'uppercase',
  py: 1,
  alignSelf: 'flex-start',
};

export const fileInfoStyles: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: 1.5,
};

export const dialpadContainerStyles: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: 1,
};

export const dialpadGridStyles: SxProps<Theme> = {
  display: 'grid',
  gridTemplateColumns: 'repeat(3, 1fr)',
  gap: 2,
};

export const dialButtonStyles: SxProps<Theme> = {
  borderRadius: '50%',
  minWidth: '48px',
  height: '48px',
};
